import { storage } from '@uhg-abyss/web/tools/storage';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import { NonGatedPcpState, StoreKeys, initialState } from './nonGatedPcpStore';

const store = (set) => ({
  ...initialState,
  [StoreKeys.SET_NON_GATED_PRIMARY_CARE_DATA]: (values) =>
    set(() => ({ [StoreKeys.NON_GATED_PRIMARY_CARE_DATA]: values })),
  [StoreKeys.CLEAR_NON_GATED_PRIMARY_CARE_DATA]: () => {
    storage.session.remove('nonGatedPcpStore');
    set(() => ({
      [StoreKeys.NON_GATED_PRIMARY_CARE_DATA]: {},
      [StoreKeys.HAS_FETCHED_NON_GATED_PRIMARY_CARE_DATA]: false,
    }));
  },
  [StoreKeys.SET_HAS_FETCHED_NON_GATED_PRIMARY_CARE_DATA]: (value) =>
    set(() => ({
      [StoreKeys.HAS_FETCHED_NON_GATED_PRIMARY_CARE_DATA]: value,
    })),
});

const nonGatedPcpStore = persist(store, {
  name: 'nonGatedPcpStore',
  storage: createJSONStorage(() => sessionStorage),
  merge: (
    persistedState: NonGatedPcpState,
    currentState: NonGatedPcpState
  ) => ({
    ...currentState,
    ...persistedState,
  }),
});

export const useNonGatedPcpStore = create(devtools(nonGatedPcpStore));
